const nav_parents = document.querySelectorAll('.nav-mobile .menu-item-has-children');

nav_parents.forEach(parent => {
    if (parent.classList.contains('current-menu-item') || parent.classList.contains('current-menu-ancestor')) {
        parent.classList.add('open-sub-menu');
    }
    parent.addEventListener('click', function(e) {
        if (e.target === e.currentTarget) {
            if (parent.classList.contains('open-sub-menu')) {
                parent.classList.remove('open-sub-menu');
                parent.querySelectorAll('.menu-item-has-children').forEach(child => {
                    child.classList.remove('open-sub-menu');
                });
            } else {
                nav_parents.forEach(check_parent => {
                    if (!check_parent.contains(parent)) {
                        check_parent.classList.remove('open-sub-menu');
                    }
                });
                parent.classList.add('open-sub-menu');
            }
        }
    });
});